var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,18.64a.61.61,0,0,1-.42-1l6.07-6.07a.59.59,0,0,1,.85,0,.61.61,0,0,1,0,.85l-6.07,6.07A.6.6,0,0,1,12,18.64Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.48,17.2a.61.61,0,0,1-.43-1l2.6-2.59a3.7,3.7,0,1,0-5.23-5.23L13.83,11A.61.61,0,0,1,13,11a.59.59,0,0,1,0-.85l2.59-2.6a4.9,4.9,0,0,1,6.93,6.93L19.9,17A.58.58,0,0,1,19.48,17.2Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11,23.93A4.87,4.87,0,0,1,6.08,19,4.85,4.85,0,0,1,7.5,15.57L10.1,13A.59.59,0,0,1,11,13a.61.61,0,0,1,0,.85l-2.6,2.59A3.67,3.67,0,0,0,7.28,19a3.69,3.69,0,0,0,6.3,2.62l2.59-2.6a.61.61,0,0,1,.85,0,.59.59,0,0,1,0,.85l-2.59,2.6A4.91,4.91,0,0,1,11,23.93Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.684be5c6540ddad13c47a44c8b6d6a49.svg";
export { ForwardRef as ReactComponent };